import Checkmark from '@otovo/shared/components/Icons/Checkmark/Checkmark';
import { Sanity$Product } from '@otovo/shared/types/sanityTypes';

type ProductCardFeaturesProps = {
  product: Sanity$Product;
  displaySubscriptionPrice: boolean;
};

type TextRowItemProps = {
  items: string[];
  productId: string;
};

const TextRowItem = ({ items, productId }: TextRowItemProps) => {
  return (
    <>
      {items.map((item) => (
        <div key={productId + item} className="mb-3 flex gap-4 md:text-[17px]">
          <Checkmark size="4" position="relative" top="1" />
          {item}
        </div>
      ))}
    </>
  );
};

const ProductCardFeatures = ({
  product,
  displaySubscriptionPrice,
}: ProductCardFeaturesProps) => {
  const { _id: productId } = product;

  return (
    <>
      {product.features?.length > 0 && (
        <TextRowItem items={product.features} productId={productId} />
      )}

      {product.buyNowGuarantees?.length > 0 &&
        displaySubscriptionPrice === false && (
          <TextRowItem items={product.buyNowGuarantees} productId={productId} />
        )}

      {product.subscriptionGuarantees?.length > 0 &&
        displaySubscriptionPrice === true && (
          <TextRowItem
            items={product.subscriptionGuarantees}
            productId={productId}
          />
        )}
    </>
  );
};

export default ProductCardFeatures;
